// Global Instructions Rule Applied!

export const SET_FILTER_OPTIONS = 'rounds/SET_FILTER_OPTIONS' as const
export const SET_ROUNDS = 'rounds/SET_ROUNDS' as const
export const SET_ACTIVE_FILTERS = 'rounds/SET_ACTIVE_FILTERS' as const
export const SET_ACTIVE_SORTING = 'rounds/SET_ACTIVE_SORTING' as const
export const CLEAR_ACTIVE_FILTERS = 'rounds/CLEAR_ACTIVE_FILTERS' as const
export const CLEAR_ACTIVE_SORTING = 'rounds/CLEAR_ACTIVE_SORTING' as const
export const UPDATE_ROUND_RECORD = 'rounds/UPDATE_ROUND_RECORD' as const
export const ADD_ROUND = 'rounds/ADD_ROUND' as const
export const REMOVE_ROUND = 'rounds/REMOVE_ROUND' as const
